import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useConfirmDialog } from '~/components/DialogsProvider';

import { deleteWidget, updateWidget } from '../../../../../../layoutSlice';
import { WidgetSettings } from '../../../../../../userSettings';

export interface UseManageDeleteAndVisibilityOutput {
  handleVisibilityToggle: () => void;
  handleDeleteWidget: () => void;
}

export const useManageDeleteAndVisibility = (
  settings: WidgetSettings,
): UseManageDeleteAndVisibilityOutput => {
  const dispatch = useDispatch();

  const handleVisibilityToggle = () => {
    dispatch(
      updateWidget({
        ...settings,
        isVisible: !settings.isVisible,
      }),
    );
  };

  const { t } = useTranslation();
  const confirm = useConfirmDialog();

  const handleDeleteWidget = useCallback(() => {
    confirm(t('widgetDeleteConfirmationMessage'), (confirmed) => {
      if (confirmed) {
        dispatch(deleteWidget(settings.id));
      }
    });
  }, [t, confirm, dispatch, settings.id]);

  return {
    handleVisibilityToggle,
    handleDeleteWidget,
  };
};
